import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { Button } from './ui/button';
import { useT } from '../i18n/I18nContext';

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  variant = 'default',
  loading = false,
}) {
  const t = useT();
  const confirmText = confirmLabel ?? t('common.confirm');
  const cancelText = cancelLabel ?? t('common.cancel');
  const handleConfirm = async () => {
    try {
      await onConfirm?.();
      onOpenChange(false);
    } catch {
      /* caller shows toast */
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-sm border-zinc-200 sm:max-w-md gap-4">
        <AlertDialogHeader className="gap-2 text-left">
          <AlertDialogTitle className="font-display text-xl font-black tracking-tight text-zinc-900">
            {title}
          </AlertDialogTitle>
          {description ? (
            <AlertDialogDescription className="text-sm text-zinc-600 leading-relaxed">
              {description}
            </AlertDialogDescription>
          ) : null}
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-2 flex-row justify-end sm:justify-end">
          <AlertDialogCancel
            disabled={loading}
            className="rounded-sm border-zinc-200 mt-0"
          >
            {cancelText}
          </AlertDialogCancel>
          <Button
            type="button"
            disabled={loading}
            className={
              variant === 'destructive'
                ? 'rounded-sm bg-red-600 text-white hover:bg-red-700'
                : 'rounded-sm bg-black text-white hover:bg-zinc-800'
            }
            onClick={handleConfirm}
          >
            {loading ? t('common.pleaseWait') : confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
